
<template>
  <div id="PDF">
    <div id="demo"></div>
  </div>
</template>
 
<script>
// 引入pdfh5

import Pdfh5 from 'pdfh5';

export default {
  name: 'pdfH5',
  data() {
    return {
      pdfh5: null,
    };
  },
  props: ['urlLink'],
  mounted() {
    this.loadPdf();
  },
  methods: {
    loadPdf() {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
      });
      console.log('cmap----')
      this.pdfh5 = new Pdfh5('#demo', {
        pdfurl: this.urlLink,
        cMapUrl:"https://unpkg.com/pdfjs-dist@2.0.943/cmaps/",
        pageNum: false,
        backTop: false,
      });
      // 监听完成事件
      this.pdfh5.on('complete', (status, msg, time) => {
        this.$toast.clear();
        console.log('是否加载完成');
        this.$emit('isLoadDone', true);
        console.log('status=', status, 'msg=', msg, 'time=', time, 'this.totalNum=', this.totalNum);
      });
    },
  },
  watch: {
    urlLink: {
      handler() {
        this.loadPdf();
      },
    },
  },
};
</script>
<style scoped>
@import "./../../../node_modules/pdfh5/css/pdfh5.css";
*{
padding: 0;
margin: 0;
}
html,body,#PDF {
width: 100%;
height: 100%;
}
#PDF >>> .pdfjs .loadEffect{
  width: 0px!important;
  height: 0px!important;
  background: chartreuse;
}
</style>
